import React from 'react';
import JobGridList from './JobGridList';
import JobSingle from './JobSingle';

export default function JobsTab(props) {
  return (
    <>
    { props.currentJob ? <JobSingle {...props} /> :
      <JobGridList items={props.jobs} click={props.jobClick} />
     }
    </>
  );
}
